import {FC} from 'react';
import {BlsDataType} from 'api/types/LeadForm';
import {BlsForm} from '@target-web/leadads-form-view';
import {AppProps} from './types';
import {VIEW} from 'utils/types';
import {useSetBarColor} from 'utils/hooks/useSetBarColor';
import {useBlsNavigation} from 'utils/hooks/useNavigation';
import useBlsFormController from 'utils/hooks/useBlsFormController';
import {bridge} from 'utils/bridge';

type AppBlsProps = AppProps & {
    formData: BlsDataType;
    formDataHash: string | null;
    layout: VIEW;
};
const AppBls: FC<AppBlsProps> = ({formData, layout}) => {
    const formController = useBlsFormController({questions: formData.questions});
    const {history, goNext, closeForm, onTransition} = useBlsNavigation({
        formData,
        formController,
    });

    useSetBarColor();

    return (
        <BlsForm
            activePanelId={history[history.length - 1]}
            layout={layout}
            formData={formData}
            formController={formController}
            goNext={goNext}
            closeForm={closeForm}
            onTransition={onTransition}
            isBridgeAvailable={!!bridge}
        />
    );
};

export default AppBls;
